/**
 * Číselník oborů pro upřesnění zaměření firmy.
 *
 * Stahuje se celý najednou a drží se v paměti. Je malý a statický, takže
 * dotaz na každou úroveň by jen zdržoval klikání ve wizardu.
 */
import { authHeaders } from '../lib/apiFetch';

const API_BASE = process.env.REACT_APP_API_BASE || '';

let rozpracovane = null;

/** Vrátí strom oborů. Opakované volání už nesahá na síť. */
export function nactiObory() {
  if (!rozpracovane) {
    rozpracovane = (async () => {
      const res = await fetch(`${API_BASE}/api/obory`, {
        headers: await authHeaders(),
      });
      if (!res.ok) {
        // Další pokus musí jít znovu na síť, jinak by se chyba držela
        // až do obnovení stránky.
        rozpracovane = null;
        throw new Error(`Číselník oborů se nepodařilo načíst (${res.status})`);
      }
      const data = await res.json();
      return data.strom || {};
    })();
  }
  return rozpracovane;
}

/**
 * Zařadí firmu do číselníku podle vlastního popisu.
 *
 * Odvozuje AI, rozhoduje číselník: obor, který ve stromu neexistuje,
 * backend zahodí. Nerozpoznáno je platná odpověď, ne chyba.
 */
export async function rozpoznejObor(popis) {
  const res = await fetch(`${API_BASE}/api/obor/rozpoznat`, {
    method: 'POST',
    headers: await authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ popis }),
  });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.detail || `Obor se nepodařilo určit (${res.status})`);
  }
  return res.json();
}

/** Uzly nabízené na dané úrovni. Prázdné pole znamená konec větve. */
export function nabidkaProUroven(strom, typ, cesta, uroven) {
  let uzly = (strom && strom[typ]) || [];
  for (let i = 0; i < uroven; i += 1) {
    const vybrany = uzly.find(o => o.klic === cesta[i]);
    if (!vybrany) return [];
    uzly = vybrany.deti || [];
  }
  return uzly;
}

/** Názvy vybraných uzlů pro drobečkovou cestu. */
export function nazvyCesty(strom, typ, cesta) {
  const out = [];
  let uzly = (strom && strom[typ]) || [];
  for (const klic of cesta) {
    const uzel = uzly.find(o => o.klic === klic);
    if (!uzel) break;
    out.push(uzel.nazev);
    uzly = uzel.deti || [];
  }
  return out;
}
